import { render, staticRenderFns } from "./Table-all-admin.vue?vue&type=template&id=0a5109e3&"
import script from "./Table-all-admin.vue?vue&type=script&lang=js&"
export * from "./Table-all-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports